import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { stockErrorMessage } from '../utils/clinicalStock';

/**
 * notes-2 F-5: the snackbar of a failed clinical write. A Warehouse refusal
 * reads in Polish (`stockErrorMessage`: 422 `RECIPIENT_REQUIRED`,
 * `WAREHOUSE_DISABLED`, …); anything else keeps the screen's own copy.
 * Call the result with that copy to get the write's `onError`.
 */
export function useStockWriteError(): (
  fallback: string,
) => (error: unknown) => void {
  const { enqueueSnackbar } = useSnackbar();
  return useCallback(
    (fallback: string) =>
      (error: unknown): void => {
        enqueueSnackbar(stockErrorMessage(error) ?? fallback, {
          variant: 'error',
        });
      },
    [enqueueSnackbar],
  );
}
